<template>
  <div class="header-image-container" :class="{ minimized: minimizedHeader }">
    <EmailComposer :selected-person-email="selectedUser.email"
                   v-model="isEmailComposerVisible">
    </EmailComposer>

    <v-row class="ma-0" style="border-radius: 10px 10px 0 0!important">
      <v-col cols="12"
             class="d-flex align-center pr-0 pt-0"
             :class="$vuetify.breakpoint.smAndDown ? 'justify-space-between' : 'justify-end'"
             style="border-radius: 10px 10px 0 0!important">
        <SideMenu :current-component="currentComponent"
                  :minimized-side-menu="minimizedSideMenu"
                  @toggleModal="toggleModal()"
                  @toggleSideMenu="toggleSideMenu()"
                  @changeCurrentComponent="changeCurrentComponent($event)"
                  v-if="$vuetify.breakpoint.smAndDown" />

        <div class="d-flex align-center">
          <v-btn color="kbGray"
                 class="mr-4 mt-4"
                 dark
                 fab
                 style="z-index: 10"
                 height="15px"
                 width="15px"
                 @click="toggleMinimizedHeader(!minimizedHeader)">
            <v-icon>{{ minimizedHeader ? 'mdi-arrow-down-drop-circle' : 'mdi-arrow-up-drop-circle' }}</v-icon>
          </v-btn>

          <v-btn class="mr-3 mt-4"
                 dark
                 icon
                 style="z-index: 10"
                 height="35px"
                 width="35px"
                 @click="toggleModal()">
            <v-icon size="30px">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <div class="header-image-container--info-bar">
      <div class="d-flex">
        <div>
          <div class="user-image-container elevation-3">
            <img :src="selectedUser.image"
                 alt="Profile Image"
                 v-show="selectedUser.image && wasImageLoadedCorrectly"
                 @load="checkProfileImageLoad(true)"
                 @error="checkProfileImageLoad(false)">
            <v-icon color="kbGrayLightText"
                    :size="minimizedHeader ? '120' : '140px'"
                    v-show="!selectedUser.image || !wasImageLoadedCorrectly">
              mdi-account-circle
            </v-icon>
          </div>
        </div>

        <div class="d-flex justify-end justify-md-space-between align-end"
             style="width: 100%">
          <div v-if="$vuetify.breakpoint.mdAndUp">
            <ContactMethodsMenu :main-color="mainColor"
                                :social-networks-registered="socialNetworksRegistered"
                                @changeCurrentComponent="changeCurrentComponent"
                                @openEmailComposerDialog="openEmailComposerDialog()">
            </ContactMethodsMenu>
          </div>

          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn class="mr-3"
                       large
                       color="kbDarkBlue"
                       @click="goToConversationsSearch(selectedUser.userId)"
                       icon
                       target="_blank"
                       v-on="on"
                       width="33"
                       height="33"
                       v-if="hasPermissionsConversations">
                  <v-img src="https://storage.googleapis.com/keybe/cloudtask/conversa2.svg" style="width: 30px"/>
                </v-btn>
              </template>
              <span>historial de conversaciones</span>
            </v-tooltip>

            <CallMenu />

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn class="mr-2"
                       :href="`https://auth.keybe.bio/user/${selectedUser.UUID}/contact/card`"
                       :download="`${selectedUser.name}.vcf`"
                       large
                       color="kbDarkBlueText"
                       icon
                       target="_blank"
                       v-on="on">
                  <v-icon size="32px">feather-download-cloud</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('general.downloadContact') }}</span>
            </v-tooltip>

            <template v-if="$vuetify.breakpoint.smAndDown">
              <ContactMethodsMenu :main-color="mainColor"
                                  :social-networks-registered="socialNetworksRegistered"
                                  @changeCurrentComponent="changeCurrentComponent" />
            </template>
          </div>
        </div>
      </div>
      <v-row>
        <v-col cols="12" class="d-md-flex justify-space-between align-center pb-0">
          <div>
            <span class="text-uppercase kbDarkBlueText--text mr-1"
                  style="font-size: 18px">
              {{ fullNameFilter(selectedUser.fullName) }}
            </span>

            <!--Ocultando la ubicación para la marca Interview research-->
            <div>
              <template v-if="appUuid !== '4xqai9uk9xd67y3'">
                <span class="font-weight-light text-capitalize kbDarkBlueText--text"
                      style="font-size: 14px"
                      v-if="userLocation">
                  {{ selectedUser.location.city }}, {{ selectedUser.location.region }}
                </span>

                <span class="font-weight-light text-capitalize kbDarkBlueText--text"
                      style="font-size: 14px"
                        v-else>
                  {{ selectedCountryPhone.country }}
                </span>
              </template>

              <v-chip v-if="selectedUser.journey && Object.keys(selectedUser.journey).length > 0"
                      class="ml-2"
                      :color="selectedUser.journey.mainColor"
                      label
                      style="cursor: pointer"
                      text-color="white"
                      x-small
                      @click="changeCurrentComponent('UserJourney')">
                {{ journeyNameFilter(selectedUser.journey.name) }}
              </v-chip>
            </div>
          </div>

          <div v-if="selectedUser.UUID && $vuetify.breakpoint.mdAndUp">
            <span class="kbDarkBlueText--text" style="font-size: 18px">{{ selectedUser.UUID }}</span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import EmailComposer from '@/components/widgets/EmailComposer'
import SideMenu from '@/pages/App/People/dialogs/ViewUser/SideMenu/SideMenu'
import CallMenu from './CallMenu'
import ContactMethodsMenu from './ContactMethodsMenu'
export default {
  components: { ContactMethodsMenu, CallMenu, EmailComposer, SideMenu },
  computed: {
    ...mapGetters(['appUuid', 'userExtraDatas']),
    ...mapState({
      administratorRoles: state => state.companies.administratorRoles,
      selectedUser: state => state.users.selectedUser
    }),
    userLocation () {
      return this.selectedUser.location &&
        this.selectedUser.location.city &&
        this.selectedUser.location.region
    },
    hasPermissionsConversations () {
      return ['ROLE_ADMIN', 'FILTER_ALL_CHATS', 'ROLE_CONVERSATIONS', 'VIEW_ALL_CHATS'].some(r => this.administratorRoles.includes(r))
    }
  },
  data () {
    return {
      isEmailComposerVisible: false,
      wasImageLoadedCorrectly: false
    }
  },
  methods: {
    changeCurrentComponent (component) {
      this.$emit('changeCurrentComponent', component)
    },
    checkProfileImageLoad (value) {
      this.wasImageLoadedCorrectly = value
    },
    fullNameFilter (value) {
      if (!value) return this.$t('general.withoutName')
      if (value.length > 35 && this.$vuetify.breakpoint.smAndDown) return value.slice(0, 35) + '...'
      if (value.length > 40 && this.$vuetify.breakpoint.mdAndUp) return value.slice(0, 40) + '...'
      return value
    },
    journeyNameFilter (value) {
      if (!value) return this.$t('general.withoutName')
      if (value.length > 25) return value.slice(0, 25) + '...'
      return value
    },
    goToConversationsSearch (userId) {
      this.$router.push({ path: '/conversations', query: { type: 'private', value: userId } })
    },
    openEmailComposerDialog () {
      this.isEmailComposerVisible = true
    },
    toggleMinimizedHeader (value) {
      this.$emit('toggleMinimizedHeader', value)
    },
    toggleModal () {
      this.$emit('toggleModal', false)
    },
    toggleSideMenu () {
      this.$emit('toggleSideMenu')
    },
    updatePerson (data) {
      this.$emit('updatePerson', data)
    }
  },
  props: {
    currentComponent: {
      type: String,
      required: true
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    mainColor: {
      type: String
    },
    minimizedHeader: {
      type: Boolean
    },
    socialNetworksRegistered: {
      type: Object
    },
    selectedCountryPhone: {
      type: Object
    }
  }
}
</script>

<style scoped>
  .header-image-container {
    background-image: url('https://storage.googleapis.com/keybe/app/images/keybe-happy-face-background.jpg');
    background-position: center;
    background-size: cover;
    border-radius: 0 10px 0 0;
    height: 150px;
    min-height: 150px;
    position: relative;
    width: 100%;
    transition: all ease-in-out 0.2s;
  }
  .header-image-container.minimized {
    height: 70px;
    min-height: 70px;
  }
  .header-image-container--info-bar {
    position: absolute;
    left: 0;
    right: 0;
    top: 80px;
    width: calc(100% - 44px);
    margin: 0 auto;
    transition: all ease-in-out 0.2s;
  }
  .header-image-container.minimized .header-image-container--info-bar {
    top: 15px;
  }
  .user-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    border-radius: 50%;
    background-color: white;
    height: 125px;
    width: 125px;
    transition: all ease-in-out 0.2s;
  }
  .header-image-container.minimized .user-image-container {
    height: 105px;
    width: 105px;
  }
  .user-image-container img {
    border: 2px solid #ffffff;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
  @media only screen and (min-width: 960px) {
    .header-image-container {
      background-position: center -150px;
      height: 160px;
    }
  }
  @media only screen and (min-width: 1600px) {
    .header-image-container {
      height: 230px;
      background-position: center -220px;
    }
    .header-image-container--info-bar {
      top: 160px;
    }
  }
</style>
